import { useMemo } from 'react';

import { useTasksController_getTasks } from '@/services/hooks';

import { mapTaskListToDomain } from './mappers';
import type { TaskList, TaskQueryFilters, UseGetTasksResult } from './types';

const EMPTY_TASK_LIST: TaskList = {
    locationId: 0,
    tasks: [],
    summary: { total: 0, active: 0, completed: 0, ignored: 0 },
};

export const useGetTasks = (locationId: number, filters?: TaskQueryFilters): UseGetTasksResult => {
    const query = useTasksController_getTasks(locationId, filters, {
        staleTime: 30_000,
        refetchOnWindowFocus: true,
        refetchInterval: 60_000,
    });

    const data = useMemo(
        () => (query.data?.data ? mapTaskListToDomain(query.data.data) : EMPTY_TASK_LIST),
        [query.data?.data]
    );

    return { ...query, isLoading: query.isPending, data };
};
